<template>
  <v-menu
    content-class="w-notification-menu"
    origin="top right"
    offset-y
    @input="setMaxHeight"
  >
    <template #activator="{ on: onMenu }">
      <v-tooltip
        class="w-tooltip"
        content-class="w-tooltip__content-wrapper"
        bottom
        color="primary"
      >
        <template #activator="{ on: onTooltip }">
          <w-btn
            color="white"
            class="v-btn--flat"
            icon
            :outlined="false"
            v-on="{ ...onMenu, ...onTooltip }"
            @click="reload()"
          >
            <WorkNotificationTrackerIcon />
          </w-btn>
        </template>

        <span class="w-tooltip__content">{{
          $t('innerNotification.words.innerNotifications')
        }}</span>
      </v-tooltip>
    </template>

    <template #default>
      <resize-handler @resize="setMaxHeight">
        <div
          class="menu-notification-title with-h-line"
          :style="`height: ${TITLE_HEIGHT}px`"
        >
          <h3>{{ $t('innerNotification.words.innerNotifications') }}</h3>
        </div>

        <div
          class="notification-wrapper"
          :style="`max-height: ${maxHeight}px`"
        >
          <div
            v-if="notificationItems.length >= 1"
            class="notification-wrapper__notifications"
          >
            <WorkNotificationItem
              v-for="notification in notificationItems"
              :key="notification.id"
              :notification-item="notification"
              @reload="reload"
            />
          </div>
          <div v-if="notificationItems.length < 1">
            {{ $t('innerNotification.sentences.noUnreadMessages') }}
          </div>
        </div>

        <div
          class="menu-notification-action d-flex justify-center with-h-line-top"
          :style="`height: ${ACTION_HEIGHT}px`"
        >
          <w-btn @click="redirectToNotifications">
            {{ $t('innerNotification.words.toInnerNotificationsOverview') }}
          </w-btn>
        </div>
      </resize-handler>
    </template>
  </v-menu>
</template>

<script>
// components
import WorkNotificationItem from '@/components/header_components/components/WorkNotificationItem';
import WorkNotificationTrackerIcon from './WorkNotificationTrackerIcon';
// service
import { mapGetters } from 'vuex';
import notificationService from '@/modules/notifications/services/notification-service';
import dateFormatter from '@/services/formatter_services/date-formatter';

const TITLE_HEIGHT = 67;
const ACTION_HEIGHT = 68;

export default {
  name: 'WorkNotificationMenu',
  components: { WorkNotificationItem, WorkNotificationTrackerIcon },
  data() {
    return {
      TITLE_HEIGHT: TITLE_HEIGHT,
      ACTION_HEIGHT: ACTION_HEIGHT,
      maxHeight: 500,
      notificationItems: [],
    };
  },
  computed: {
    ...mapGetters('notifications', ['getUnreadNotifications']),
  
  },
  methods: {
    async reload() {
      var promise = await notificationService.getUnread();
      this.notificationItems = promise.data.data.filter((n) => !n.data.readOn);
    },
    redirectToNotifications() {
      this.$router.push({
        name: 'NotificationsOverview',
      });
    },
    async setMaxHeight() {
      let clientHeight = document.documentElement.clientHeight;
      let headerBarHeight =
        document.getElementsByClassName('work-header-bar')[0].clientHeight;

      this.maxHeight =
        clientHeight - headerBarHeight - TITLE_HEIGHT - ACTION_HEIGHT;
    },
    sortDates(first, second) {
      return (
        dateFormatter.formateLocaleStringToDate(
          second.data.createdAt.substring(0, 11)
        ) -
        dateFormatter.formateLocaleStringToDate(
          first.data.createdAt.substring(0, 11)
        )
      );
    },
    sortTimes(first, second) {
      return (
        dateFormatter.formatFormattedWorkingHoursToMinutes(
          second.data.createdAt.substring(11, second.length)
        ) -
        dateFormatter.formatFormattedWorkingHoursToMinutes(
          first.data.createdAt.substring(11, second.length)
        )
      );
    },
    sortByCreatedAt(notificationsUnsorted) {
      return notificationsUnsorted.sort((first, second) =>
        first == undefined || second == undefined
          ? 0
          : this.sortDates(first, second) == 0
          ? this.sortTimes(first, second)
          : this.sortDates(first, second)
      );
    },
  },
  mounted() {
    this.reload();
  },
  watch: {
    getUnreadNotifications() {
      this.reload();
    },
  },
};
</script>

<style lang="scss" scoped>
$default-spacing: calc(#{$grid-gutter} + (#{$grid-gutter} / 2));

.menu-notification-title,
.menu-notification-action {
  padding: #{$grid-gutter};
  background: $dialog-bg-color;
}

.w-notification-menu {
  top: $nav-bar-height !important;
  right: 0 !important;
  left: unset !important;
  @include default-border
}

.notification-wrapper {
  overflow: auto;
  max-width: 33rem;
  border-top: #{$default-spacing} solid var(--v-work_card-base);
  border-bottom: #{$default-spacing} solid var(--v-work_card-base);
  padding-left: #{$default-spacing};
  padding-right: #{$default-spacing};
  background: $dialog-bg-color;
}

.notification-wrapper__notifications ::v-deep .notification-box:first-child {
  .notification__icon__wrapper {
    border-top: 0 !important;
  }

  .notification__content {
    margin-top: $half-grid-gutter;
  }
}

.notification-wrapper__notifications ::v-deep .notification-box:last-child {
  .notification__icon__wrapper {
    height: auto;
    background-color: var(--v-work_card-base);
  }

  .notfication__content__message {
    margin-bottom: 0 !important;
  }
}
</style>
